(ns practitest.frontend.integration-settings.shared-form
  (:require [practitest.frontend.common.i18n :refer [get-translation format-translation]]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components2.spinners :as spinners]
            [practitest.frontend.components.selector2 :as selector2]))

(defn transform-project-for-selector [project]
  {:id    (keyword (:id project))
   :label (:name project)})

(defn filter-selected-projects [projects selected-project-ids]
  (set (filter #(contains? selected-project-ids (:id %)) projects)))

(defn get-sync-tooltip-text [entity-type bugtracker]
  (if (= entity-type :requirements)
    (format-translation (get-translation "bugtracker.integration-settings.requirements-sync.tooltip"
                                         "Enable synchronization between %{bugtracker} and PractiTest Requirements")
                        :bugtracker bugtracker)
    (format-translation (get-translation "bugtracker.integration-settings.issues-sync.tooltip"
                                         "Enable synchronization between %{bugtracker} and PractiTest Issues")
                        :bugtracker bugtracker)))

(defn get-entity-label [entity-type]
  (if (= entity-type :requirements) "requirement" "issue"))

(defn get-other-entity-type [entity-type]
  (if (= entity-type :requirements) :issues :requirements))

(defn get-pt-entity-label [entity-type]
  (if (= entity-type :requirements)
    (get-translation "requirement.singular" "Requirement")
    (get-translation "issue.singular" "Issue")))

(defn checkbox [{:keys [checked? on-change disabled? disabled-tooltip]}]
  [:input.m-checkbox
   {:type      "checkbox"
    :checked   checked?
    :disabled  disabled?
    :title     (when disabled? disabled-tooltip)
    :on-change on-change}])

(defn toggle-switch [{:keys [enabled? on-change disabled?]}]
  [:div.form-switch
   [:input.form-check-input
    {:type      "checkbox"
     :checked   enabled?
     :disabled  disabled?
     :on-change #(on-change (.. % -target -checked))}]])

;; Generic row used in both JIRA and Azure entity mapping sections.
;; Props:
;;   :project-name   - display name of the project (read-only)
;;   :type-options   - seq of {:id :label} for the type dropdown
;;   :selected-types - seq of selected type IDs
;;   :pt-entity      - display label for the PT entity (read-only)
;;   :placeholder    - placeholder text for the type selector
;;   :on-types-change - fn called with new vec of selected type IDs
;;   :on-toggle      - fn called when enable/disable link is clicked
;;   :disabled?      - whether this row is disabled
;;   :types-loading? - whether types are still being fetched
(defn project-mapping-row
  [{:keys [project-name type-options selected-types pt-entity placeholder
           on-types-change on-toggle disabled? types-loading?]}]
  [:div.mapping-row
   {:class (when disabled? "disabled")}
   [:input.form-control.project-name-input
    {:type     "text"
     :value    project-name
     :disabled true}]
   [:div.type-selector-wrapper
    [selector2/new-select
     {:multi?      true
      :disabled?   disabled?
      :tags?       false
      :value       (set (filter #(contains? (set selected-types) (:id %)) type-options))
      :items       type-options
      :key-fn      :id
      :label-fn    :label
      :placeholder (str placeholder "...")
      :on-change   (fn [selected-set]
                     (on-types-change (vec (map :id selected-set))))}]
    (when types-loading?
      [:span.type-selector-loading
       [spinners/mux-spinner {:size :small}]])]
   [icons/mux-up-down]
   [:input.form-control.pt-entity-input
    {:type     "text"
     :value    pt-entity
     :disabled true}]
   [:a.disable-link
    {:href     "#"
     :on-click (fn [e]
                 (.preventDefault e)
                 (on-toggle))}
    (if disabled?
      [:<> [icons/mux-circle-plus] " " (get-translation "generic.label.enable" "Enable")]
      [:<> [icons/mux-circle-less] " " (get-translation "generic.label.disable" "Disable")])]])
